import React from 'react';
import styled from 'styled-components';
import Card from '../../components/ui/Card';

const PageContainer = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const Title = styled.h1`
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 2rem;
`;

const PlanManagement = () => {
  return (
    <PageContainer>
      <Title>Plan Management</Title>
      <Subtitle>Create and manage meal and fitness plans for your clients.</Subtitle>
      
      <Card>
        <Card.Content>
          <p>Plan Management content will be implemented soon.</p>
        </Card.Content>
      </Card>
    </PageContainer>
  );
};

export default PlanManagement; 